import { ORDER_STATUS } from 'my-purchases/constants/orderStatus'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'

interface GetDeliveryAndExpiredLabelProps {
	desktopDetails: string
	type: ORDER_TYPES
	isActive: boolean
	status: ORDER_STATUS
}

export function getDeliveryAndExpiredLabel({
	desktopDetails,
	type,
	isActive,
	status,
}: GetDeliveryAndExpiredLabelProps) {
	let info = desktopDetails
	if (type === ORDER_TYPES.STORE) {
		info = 'myPurchases.store.details.delivered.title'
	}
	if (!isActive && status !== ORDER_STATUS.cancelled) {
		info = 'myPurchases.details.returnsExpired.text'
	}

	return {
		statusMessage: info ?? '',
	}
}
